module.exports = __webpack_public_path__ + "40a29f45419943600454a256d833e2e4.png";